<template>
  <div class="wrapper">
    <header>
      <div class="header_title" v-if="isEditProps">
        上传素材
      </div>
      <div class="header_title" v-else>
        素材
      </div>
    </header>
    <div class="material_upload_body">
      <a-spin :spinning="fullImgLoading" tip="正在上传...">
        <a-upload
          v-if="!currentAdMaterialDetail.fullImageUrl && isEditProps"
          :src="currentAdMaterialDetail.fullImageUrl"
          name="file"
          listType="picture-card"
          :showUploadList="false"
          :action="uploadMaterialImgUrl"
          :beforeUpload="beforeUploadFun"
          :headers="headers"
          @change="handleChangeMaterial"
        >
          <div class="m-updataing">
            <div class="u-ant-upload-img">
              <a-icon type="picture" width="35px" height="28px" />
            </div>
            <div class="u-ant-upload-text">点击上传</div>
            <div class="u-ant-upload-info">尺寸:{{ materialSize.w }}px *{{ materialSize.h }}px</div>
            <div class="u-ant-upload-info">格式:jpg、png、mp4</div>
            <div class="u-ant-upload-info">图片不大于1mb，视频不大于30mb</div>
          </div>
        </a-upload>

        <div v-if="currentAdMaterialDetail.fullImageUrl" class="m-updataed">
          <div class="m-bg-img">
            <img
              :src="currentAdMaterialDetail.fullImageUrl"
              v-show="currentAdMaterialDetail.fileType === 1"
            />
            <video
              id="material_video"
              ref="materialVideo"
              :src="currentAdMaterialDetail.fullImageUrl"
              controls="controls"
              v-show="currentAdMaterialDetail.fileType === 3 && !fullImgLoading"
            ></video>
          </div>
          <div class="m-img-info">
            <div class="u-download-img" @click="downloadImg">
              <a-icon type="vertical-align-bottom" />
              <div class="">下载</div>
            </div>
            <div class="u-preview" @click.stop="showImg()">
              <a-icon type="zoom-in" />
              <div class="">查看</div>
            </div>
            <div
              class="u-delect"
              v-show="canReplaceMaterial() && isEditProps"
              @click="delectFramesMaterial({})"
            >
              <a-icon type="delete" />
              <div class="">删除</div>
            </div>
          </div>
        </div>
        <div v-if="!currentAdMaterialDetail.fullImageUrl && !isEditProps" class="no_img">
          <div class="no_img_text">
            暂未上传素材
          </div>
        </div>
        <div class="play_is_duration">
          <span>播放时长：</span>
          <span>{{ isDuration }}秒</span>
        </div>
      </a-spin>
    </div>
    <a-modal
      class="u-show-img"
      :visible="visibleImg"
      cancelText="关闭"
      okText=""
      :footer="null"
      @cancel="handleCancel"
      @ok="handleCancel"
    >
      <img :src="showImgUrl" />
    </a-modal>
    <a-modal
      class="u-show-video"
      :visible="visibleVideo"
      cancelText="关闭"
      :footer="null"
      @cancel="handleCancel"
      @ok="handleCancel"
    >
      <video
        ref="showMaterialVideo"
        :src="showVideoUrl"
        controls="controls"
        autoplay="autoplay"
      ></video>
    </a-modal>
  </div>
</template>

<script>
import { config } from '../../../utils/config'
import { api } from '../../../commomFun/api'
import checkUpload from '../../../commomFun/checkUploadFile'
import { mapState, mapMutations } from 'vuex'
export default {
  props: {
    isDuration: {
      type: Number,
      default: ''
    },
    materialSize: {
      type: Object,
      default: {}
    },
    isEdit: {
      type: Boolean,
      default: true
    },
    planId: {
      type: String,
      default: ''
    },
    // 是否存在待审核记录（H5审核），审批中不允许编辑画面素材
    isExistH5Audit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      //正在上传loading
      fullImgLoading: false,
      //上传图片地址
      uploadMaterialImgUrl: config.uploadMaterialImgUrl,
      //图片放大
      visibleImg: false,
      //视频放大
      visibleVideo: false,
      showImgUrl: '',
      showVideoUrl: '',
      isUpload: '', //是否在上传
      headers: {
        token: JSON.parse(window.sessionStorage.userInfo).token,
        uid: JSON.parse(window.sessionStorage.userInfo).userId
      },
      isEditProps: false,
      isPlay: false //是否为播放中
    }
  },
  computed: {
    ...mapState(['currentAdMaterialDetail', 'framesList'])
  },
  watch: {
    isEdit: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.isEditProps = newVal
      },
      immediate: true
    }
  },
  // created() {},
  methods: {
    ...mapMutations(['changeFramesMaterial', 'changeUploadStatu']),
    // 上传前的校验
    beforeUploadFun(file) {
      if (!this.isCheckFrames()) {
        this.$message.warning('请选择画面')
        return new Promise((resolve, reject) => {
          reject()
        })
      }
      return checkUpload.beforeFile(file, this.materialSize.w, this.materialSize.h, this.isDuration)
    },
    //上传图片
    handleChangeMaterial(info) {
      if (info.file.status === 'uploading') {
        this.fullImgLoading = true
        this.changeUploadStatu(true)
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.code === 200) {
          this.fullImgLoading = false
          let data = info.file.response.data
          let activeMaterial = {}
          activeMaterial.fullImageUrl = data.fileUrl
          activeMaterial.fullImageName = data.fileName
          activeMaterial.planId = this.planId ? this.planId : ''
          activeMaterial.fileType = data.fileType
          activeMaterial.fullImageFileId = data.fileId
          activeMaterial.fullImageFileMd5 = data.fileMd5
          activeMaterial.fullImageFileUrl = data.fileUrl
          activeMaterial.adSpace = 3 // 1为上半屏，2为下半屏，3为下半屏+上半屏（也就是全屏）
          activeMaterial.fileId = data.fileId
          activeMaterial.fileCryptUrl = data.fileCryptUrl
          activeMaterial.videoSnapshotUrl = data.videoSnapshotUrl
          activeMaterial.materialInfo = JSON.stringify(data.materialInfo)
          //保留画面原有属性：上传响应不含这些字段，整体替换后会丢失，
          //导致投放中待审核画面的素材变更判断失效（报“未有信息变更”）、保存参数 detailsId/isNew 错误
          activeMaterial.id = this.currentAdMaterialDetail.id
          activeMaterial.materialId = this.currentAdMaterialDetail.materialId
          activeMaterial.isNew = this.currentAdMaterialDetail.isNew
          activeMaterial.auditStatus = this.currentAdMaterialDetail.auditStatus
          activeMaterial.isPlay = this.currentAdMaterialDetail.isPlay
          //在上传完成前切换会出现，物料 跑到其他画面的情况
          this.delectFramesMaterial(activeMaterial)
          this.changeUploadStatu(false)
        } else {
          this.$message.warning(info.file.response.msg || '素材上传异常')
          this.fullImgLoading = false
        }
      }
    },
    // 放大
    showImg() {
      if (this.currentAdMaterialDetail.fileType === 1) {
        // 图片放大
        this.visibleImg = true
        this.showImgUrl = this.currentAdMaterialDetail.fullImageUrl
      } else {
        // 视频放大
        this.visibleVideo = true
        this.showVideoUrl = this.currentAdMaterialDetail.fullImageUrl
      }
    },
    // 放大关闭
    handleCancel() {
      this.visibleImg = false
      this.visibleVideo = false
      let video = this.$refs.showMaterialVideo
      if (video) {
        video.pause()
      }
    },
    // 下载图片
    async downloadImg() {
      const imgUrl = this.currentAdMaterialDetail.fullImageFileUrl
      const checkedFrame = this.framesList.filter(item => item.checked)[0]
      const fileName = (checkedFrame && checkedFrame.framesName) || 'photo'
      if (!imgUrl) {
        return this.$message.warning('素材地址为空，无法下载')
      }
      // 下载接口已增加登录鉴权，改为 axios 请求以携带 token（浏览器原生 a 标签无法带自定义请求头）
      const res = await api.getApi_file('/material/downLoad', { url: imgUrl, fileName })
      if (!res || !res.data) {
        return this.$message.error('素材下载失败')
      }
      // 后端校验未通过（未登录、地址非法等）会返回 JSON 提示，此时不触发下载
      const contentType = (res.headers && res.headers['content-type']) || ''
      if (contentType.indexOf('application/json') > -1) {
        const reader = new FileReader()
        reader.onload = () => {
          let msg = '素材下载失败'
          try {
            msg = JSON.parse(reader.result).msg || msg
          } catch (e) {
            // JSON 解析失败时保留默认提示文案
          }
          this.$message.error(msg)
        }
        reader.readAsText(res.data)
        return
      }
      // 文件名优先取后端返回的 Content-Disposition（已带后缀）
      let downloadName = fileName
      const disposition = res.headers && res.headers['content-disposition']
      if (disposition) {
        const matched = disposition.match(/filename="?([^";]+)"?/)
        if (matched && matched[1]) {
          try {
            downloadName = decodeURIComponent(matched[1])
          } catch (e) {
            // 解码失败时直接使用原始文件名
            downloadName = matched[1]
          }
        }
      }
      const href = window.URL.createObjectURL(new Blob([res.data]))
      const a = document.createElement('a')
      a.href = href
      a.download = downloadName
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(href)
    },
    delectFramesMaterial(obj) {
      //如果订单是播放中且当前画面不可替换素材，这个物料不能被删除
      if (!this.canReplaceMaterial()) {
        return this.$message.warning('订单为播放中素材不能删除')
      }
      //清空式删除（手动删素材）时保留画面自身属性：id、审核状态、播放锁定标记等
      //否则删除后画面信息被清空，重新上传时无法恢复这些字段，
      //导致保存参数 detailsId/isNew 错误、待审核状态判断失效
      if (!obj || !Object.keys(obj).length) {
        const keep = this.currentAdMaterialDetail
        obj = {
          id: keep.id,
          materialId: keep.materialId,
          isNew: keep.isNew,
          auditStatus: keep.auditStatus,
          isPlay: keep.isPlay
        }
      }
      this.changeFramesMaterial(obj)
    },
    //判断是否选择画面
    isCheckFrames() {
      return this.framesList.find(item => {
        return item.checked
      })
    },
    getIsPlay() {
      return this.currentAdMaterialDetail.isPlay
    },
    //当前选中画面的素材是否可替换
    //非播放中订单一律可替换；播放中订单默认锁定，仅待审核(auditStatus=0)且不存在审批中记录的画面可替换
    canReplaceMaterial() {
      if (!this.getIsPlay()) return true
      return !this.isExistH5Audit && this.currentAdMaterialDetail.auditStatus === 0
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  header {
    height: 54px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    line-height: 54px;
    text-align: center;
    .header_title {
      text-align: left;
      margin-left: 16px;
      height: 54px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 54px;
    }
  }
  /deep/ .material_upload_body {
    width: 272px;
    // height: 390px;
    margin: 16px auto 8px;
    // padding-top: 22px;
    border-radius: 8px;
    background-size: contain;
    .play_is_duration {
      height: 32px;
      background: rgba(0, 0, 0, 0.05);
      text-align: center;
      span {
        line-height: 32px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
      }
    }
    .ant-upload {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .m-updataing {
      height: 390px;
      padding-top: 50%;

      .u-ant-upload-img {
        height: 28px;
        font-size: 20px;

        i {
          color: #1890ff;

          svg {
            width: 37px;
            height: 30px;
          }
        }
      }

      .u-ant-upload-text {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
      }

      .u-ant-upload-info {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.43);
        line-height: 20px;
      }
    }

    .m-updataed {
      margin-bottom: 8px;
      &:hover .u-download-img {
        display: block;
      }
      &:hover .u-preview {
        display: block;
      }
      &:hover .u-delect {
        display: block;
      }

      &:hover .m-img-info {
        background-color: rgba(0, 0, 0, 0.3);
      }
      .m-bg-img {
        width: 272px;
        height: 390px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        video {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }

      .m-img-info {
        display: flex;
        padding: 0 50px;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        top: 0;
        // width: 240px;
        // height: 265px;
        width: 100%;
        height: 390px;

        .u-ant-upload-img {
          position: relative;
          margin: 0px auto 12px;
          padding-top: 121px;
          width: 35px;
          height: 28px;
          font-size: 20px;
          box-sizing: content-box;

          i {
            position: absolute;

            &:first-child {
              color: #1890ff;

              svg {
                width: 37px;
                height: 30px;
              }
            }

            &:last-child {
              bottom: -2px;
              right: -2px;
              color: #52c41a;

              svg {
                width: 14px;
                height: 14px;
              }
            }
          }
        }

        .u-ant-upload-text {
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
          text-align: center;
          margin-bottom: 10px;
        }

        .u-ant-upload-info {
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.43);
          line-height: 20px;
          text-align: center;
        }
      }
      .u-clost-updata {
        position: absolute;
        top: -10px;
        right: -10px;
        width: 20px;
        height: 20px;
        cursor: pointer;
        color: #de2c2c;

        svg {
          width: 100%;
          height: 100%;
        }
      }
      .u-download-img,
      .u-preview,
      .u-delect {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        cursor: pointer;
        font-size: 24px;
        display: none;
        div {
          margin-top: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 20px;
        }
      }
    }
    .no_img {
      display: flex;
      margin-bottom: 8px;
      justify-content: center;
      align-items: center;
      height: 390px;
      width: 100%;
      background-color: #fafafa;
      border: 1px dashed #d9d9d9;
      border-radius: 5px;
      .no_img_text {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.25);
      }
    }
  }
}
.u-show-img {
  img {
    width: 100%;
    height: 100%;
  }
}

.u-show-video {
  video {
    width: 100%;
    height: 100%;
  }
}

.u-show-img,
.u-show-video {
  .ant-modal-footer {
    .ant-btn-primary {
      display: none;
    }
  }
}
</style>
